import { render, staticRenderFns } from "./channel-roulette.vue?vue&type=template&id=54548ea6&lang=pug&"
import script from "./channel-roulette.vue?vue&type=script&lang=js&"
export * from "./channel-roulette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports